import Layout from '@/components/feature/Layout';

export default function DebtPage() {
  return (
    <Layout>
      <div className="bg-primary-900 py-16 md:py-24">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-400 mb-3">
            Usuarios
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Consultar Deuda
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Accede a tu portal de usuario para consultar tu deuda, historial de pagos y estado de cuenta.
          </p>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-xl mx-auto">
          {/* Info card */}
          <div className="p-8 md:p-10 rounded-xl bg-background-50 border border-background-200/70 text-center">
            <div className="w-16 h-16 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-6">
              <i className="ri-user-settings-line text-primary-600 text-2xl w-8 h-8 flex items-center justify-center"></i>
            </div>

            <h2 className="font-heading font-semibold text-xl text-foreground-950 mb-3">
              Portal de Usuario
            </h2>
            <p className="text-sm text-foreground-600 mb-2 leading-relaxed">
              Consulta tu deuda, historial de pagos, lecturas anteriores y descarga tus recibos desde el portal de CODESAJAN.
            </p>
            <p className="text-xs text-foreground-500 mb-8">
              Disponible las 24 horas del día, los 7 días de la semana.
            </p>

            <a
              href="https://codesajancuenta.fluxbostudio.com"
              className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-xl transition-all duration-300 hover:-translate-y-0.5 text-base"
            >
              <i className="ri-external-link-line w-5 h-5 flex items-center justify-center"></i>
              Consultar mi cuenta
            </a>

            <p className="text-xs text-foreground-400 mt-6">
              Serás redirigido al portal de cuentas de CODESAJAN.
            </p>
          </div>

          {/* WhatsApp alternative */}
          <div className="mt-6 text-center">
            <p className="text-sm text-foreground-500 mb-3">
              ¿No podés acceder al portal?
            </p>
            <a
              href="https://wa.me/59173455233?text=Hola%20CODESAJAN,%20necesito%20consultar%20mi%20deuda"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors text-sm"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
              Consultar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
}